<template>
	<Loading :show="carregandoInterno" :text="mensagemCarregando" style="height: 100%; padding-top: 90px;"
		class="px-5 px-lg-15 mb-8 h-100">
		<v-container fluid v-if="$slots.titulo || $slots.botaoHeader">
			<v-row justify="space-between" align="center">
				<v-col cols="auto" :class="corTexto">
					<h1><slot name="titulo"/></h1>
				</v-col>
				<v-col cols="auto" class="d-flex justify-end">
					<slot name="botaoHeader"/>
				</v-col>
			</v-row>
		</v-container>
		<slot/>
		<v-container fluid v-if="$slots.footerEsquerda || $slots.footerDireita">
			<v-row justify="space-between" align="center">
				<v-col cols="6">
					<slot name="footerEsquerda"/>
				</v-col>
				<v-col cols="6" class="d-flex justify-end">
					<slot name="footerDireita"/>
				</v-col>
			</v-row>
		</v-container>
	</Loading>
</template>

<script setup>
import Loading from "@/components/commons/loading/Loading.vue";
import { usuarioPossuiPermissao } from "@/utils/PermissaoUtils.js";
import { vuetify } from '@/plugins/vuetify'
import { onMounted, ref, watch, computed } from "vue";
import { useRouter } from 'vue-router'
import store from '@/store';

const router = useRouter();

const props = defineProps({
	carregando: Boolean,
	mensagemCarregando: {
		type: String,
		default: "Carregando",
	},
	permissao: String,
})

const validouPermissao = ref(false);
const usuarioLogado = ref(store.getters["usuario/getUsuarioLogado"]);

const corTexto = computed(() => {
	return vuetify.theme.current.value.dark ? "titulo-dark" : "titulo";
})

const carregandoInterno = computed(() => {
	return props.carregando || (!!props.permissao && !validouPermissao.value);
})

function validarPermissaoUsuarioLogado(redirecionar) {
	if (!props.permissao) {
		return;
	}

	if (usuarioPossuiPermissao(usuarioLogado.value, props.permissao)) {
		validouPermissao.value = true;
	}
	else if (redirecionar) {
		console.warn("Você não possui permissão para acessar esta tela!");
		router.push("/")
	}
	else if (usuarioLogado.value !== null) {
		validarPermissaoUsuarioLogado(true);
	}
}

onMounted(() => {
	validarPermissaoUsuarioLogado(false);
})

watch(usuarioLogado.value, () => {
	if (usuarioLogado.value !== null) {
		validarPermissaoUsuarioLogado(true);
	}
})
</script>

<style lang="scss" scoped>
.titulo {
	color: var(--primary);
}
.titulo-dark {
	color: var(--white);
}
</style>
